import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import { Button} from 'react-bootstrap';
import SvgIcon from 'react-icons-kit';
import {pencil2} from 'react-icons-kit/icomoon/pencil2';


const Config = require('../../config');
var session = sessionStorage.getItem('health_facilities_name');
const style = {
  margin: 7,
};


const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

class TransfusionList extends Component{
	constructor(props){
		super(props);

		this.openForm = this.openForm.bind(this);
		this.getList = this.getList.bind(this);
		this.setTable = this.setTable.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSearch = this.onSearch.bind(this);

		var aux_date = new Date();

		this.state = {
			list: [],
			all:'false',
			check_all:false,
			columns:[
				{title:'No. Unidad', visible:true},
				{title:'Componente', visible:true},
				{title:'Fecha', visible:true},
				{title:'', visible:true}
			],
			start_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
		}
	}

	componentDidMount(){
		this.getList();
	}

	getList(){
		fetch(Config.default.apiGateway.URL+'transfusional_control/?start_date='+this.state.start_date+
			'&end_date='+this.state.end_date+'&show_all='+this.state.all+
			'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'),{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				
				this.setState({
					list:response
				})
				
				setTimeout(()=>{
					this.setTable();
				}, 300);
			}
		});
	}

	openForm(id, hospital, patient, type){
		this.props.history.push('/transfusional_control/form/'+id);
	}

	setTable(){
		this.props.waiting.handleClose();
		this.$el = $(this.el);
					
		var table = this.$el.DataTable({
			dom: '<"toolbar">frtip',
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando..."
			},
			paging:false,
			searching: true,
			autoWidth: false,
			ordering:false,
			info:false,
			
		});

		$(".toolbar").html(
			'<input type="checkbox" class="show_all_small" '+(this.state.check_all ? 'checked ' : '')+'/> Ver todos'
		);
		$(document).off('click').on('click', '.show_all_small', (e)=>{
			this.setState({
				all: e.target.checked ? 'true' : 'false',
				check_all: e.target.checked ? true : false
			});
			
			setTimeout(()=>{
				this.$el = $(this.el);
				this.$el.DataTable().destroy();
				this.props.waiting.handleShow('Cargando...');
				this.getList();
			}, 500);
			
		})

		$('.dataTables_filter').css('float', 'left');
		$('.dataTables_wrapper .dt-buttons').css('float', 'right')

		$('.toolbar').css('width', '25%');
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	onSearch(){
  		setTimeout(()=>{
			this.$el = $(this.el);
			this.$el.DataTable().destroy();
		}, 500);

		setTimeout(()=>{
			this.getList();
  		}, 1000);		
  	}

	render(){
		const {t} = this.props;
		var type = this.props.match.path.split('/');
		return (
			<div className="col-xs-12">
				<h5 className="title_page" >
					Hemovigilancia -> 
					Listado
				</h5>

				<div className="form-group col-xs-12">
					<div className="col-xs-5 form-group" style={{paddingLeft:"0"}}>
						<span className="span-min">Fecha Desde</span>
						<input type="date" className="form-control hour-input" name="start_date" id="start_date"
							value={this.state.start_date} onChange={this.handleChange} required />
					</div>
					<div className="col-xs-5 form-group" style={{paddingRight:"0"}}>
						<span className="span-min">Fecha Hasta</span>
						<input type="date" className="form-control hour-input" name="end_date" id="end_date"
							value={this.state.end_date} onChange={this.handleChange} required />
					</div>
					<div className="col-xs-1">
						<button className="btn btn-info" style={{marginTop:'18px'}} onClick={this.onSearch}>Buscar</button>
					</div>
				</div>
				<div className="col-xs-12" >
					<div >
						<table style={{fontSize:"11px"}} width="100%" ref={el => this.el = el}>
							<thead>
								<tr>
									<th>Unidad</th>
									<th>Componente</th>
									<th>Fecha </th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{this.state.list.map((l, i)=>(
									<tr key={i}>
										<td>{l.unit_number}</td>
										<td>{l.component+' '+l.component_number}</td>
										<td>{moment(l.sended).format('DD/MM/YYYY')} {moment(l.sended).format('HH:mm')}</td>
										<td>
											<button className="btn" title="Editar" 
												style={l.flag_during && l.flag_end && l.flag_start ?
														{background:'rgb(var(--primary))', marginRight:'5px', color:'white'}
													: !l.flag_during && !l.flag_end && !l.flag_start ?
														{background:'#a39f9f', marginRight:'5px', color:'white'}
													:{background:'rgba(var(--primary), 0.5)',marginRight:"5px", color:'white'}} 
												onClick={this.openForm.bind(this, l.unit_id, l.hospital, l.patient, type[2].toUpperCase())}>
												<SvgIcon icon={pencil2} />
											</button>
											{/*<Button className="btn btn-info btn-xs" title="Editar" style={{marginRight:"5px"}} 
											
												onClick={this.openForm.bind(this, l.unit_id, l.hospital, l.patient, type[2].toUpperCase())}
												>
												<SvgIcon icon={pencil2} />
											</Button>*/}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>

				
			</div>
		)
	}
}

export default translate('translations')(TransfusionList);